import React, { useEffect, useState } from "react";
import ReactFlow, { Node, Edge, NodeChange, EdgeChange, applyNodeChanges, applyEdgeChanges, ProOptions, addEdge, Connection, Handle, Position } from "reactflow";
import { useNavigate } from "react-router-dom";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dialog } from 'primereact/dialog';
import "./Focus365.css";
import { microsoftGlobalProvider, ProviderState } from "../auth/microsoftAuth";

// import copilot from "../assets/images/copilot.png";
import dot from "../assets/dot.png";

const CustomNode = ({ data }: { data: any }) => {
    return (
        <div className="custom-node">
            {data.bookmarked ?
                <div className="pi pi-bookmark-fill custom-node-bookmark" onClick={() => data.bookmarked = false} />
                :
                <div className="pi pi-bookmark custom-node-bookmark" onClick={() => data.bookmarked = true} />
            }
            <img src={dot} className="custom-node-dot" alt="copilot" />
            <div className="custom-node-header">{data.label}</div>
            <div className="custom-node-body">{data.body}</div>
            <Handle type="source" position={Position.Bottom} />
            <Handle type="target" position={Position.Top} />
        </div>
    );
};

const nodeTypes = {
    customNode: CustomNode,
};

const Focus365 = () => {
    const proOptions: ProOptions = { account: "paid-pro", hideAttribution: true };
    const navigate = useNavigate();
    const [nodes, setNodes] = useState<Node[]>([]);
    const [edges, setEdges] = useState<Edge[]>([]);
    const [selectedNode, setSelectedNode] = useState<Node | null>(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [dialogText, setDialogText] = useState("");
    const [myQuery, setMyQuery] = useState("");

    useEffect(() => {
        //fetchGraphData(null);
    }, []);

    useEffect(() => {
        if (myQuery && myQuery.trim() !== "")
            fetchGraphData(myQuery);
    }, [myQuery]);




    const fetchGraphData = async (query: string | null) => {
        try {
            const provider = microsoftGlobalProvider;

            if (!provider || provider.state !== ProviderState.SignedIn) {
                if (provider?.login) {
                    await provider.login();
                }
            }

            if (provider && provider.state === ProviderState.SignedIn) {
                await provider.getAccessToken({ scopes: ["User.Read", "Mail.Read", "Calendars.Read"] });

                const graphClient = provider.graph.client;

                const emails = await graphClient.api('/me/messages')
                    .search(`\"${query}\"`)
                    .select('subject,bodyPreview,receivedDateTime,hasAttachments,webLink')
                    .get();

                const events = await graphClient.api('/me/events')
                    .select('subject')
                    .filter(query ? `contains(subject,'${query}')` : '')
                    .get();

                // 🎯 Opret dynamiske noder for brugerens data
                const canvasElement = document.querySelector('.canvas');
                const canvasWidth = canvasElement ? canvasElement.clientWidth : 800; // Fallback to 800 if not found
                const canvasHeight = canvasElement ? canvasElement.clientHeight : 600; // Fallback to 600 if not found
                const emailNodes = emails.value.map((email: { id: string, subject: string, bodyPreview: string, receivedDateTime: string, hasAttachments: boolean, webLink: string, sourceId?: string }, index: number) => ({
                    id: `email-${email.id}`,
                    type: 'customNode',
                    data: {
                        emailId: `${email.id}`,
                        label: `${email.subject}`,
                        body: `${email.bodyPreview}`,
                        receivedDateTime: `${email.receivedDateTime}`,
                        hasAttachments: `${email.hasAttachments ? 'Has Attachments' : 'No Attachments'}`,
                        webLink: `${email.webLink}`,
                        bookmarked: false,
                        sourceId: email.sourceId || null
                    },
                    position: { x: (index % 2) * (canvasWidth / 2) + 50, y: Math.floor(index / 2) * 100 + 300 },
                }));

                const eventNodes = events.value.map((event: { subject: string }, index: number) => ({
                    id: `event-${index}`,
                    type: 'customNode',
                    data: {
                        label: `Event ${index + 1}`,
                        body: event.subject
                    },
                    position: { x: 300, y: 300 + index * 50 },
                }));

                setNodes([
                    { id: "1", type: 'customNode', data: { label: "Bruger", body: "" }, position: { x: 250, y: 50 } },
                    { id: "2", type: 'customNode', data: { label: "E-mails", body: "" }, position: { x: 100, y: 200 } },
                    { id: "3", type: 'customNode', data: { label: "Kalender", body: "" }, position: { x: 300, y: 200 } },
                    ...emailNodes,
                    ...eventNodes,
                ]);

                // setEdges([
                //     { id: "e1-2", source: "1", target: "2", type: "default" },
                //     { id: "e1-3", source: "1", target: "3", type: "default" },
                //     ...emailNodes.map((n: Node) => ({ id: `e2-${n.id}`, source: "2", target: n.id, type: "default" })),
                //     ...eventNodes.map((n: Node) => ({ id: `e3-${n.id}`, source: "3", target: n.id, type: "default" })),
                // ]);
            }
            setMyQuery("");
        } catch (error) {
            console.error("Error fetching graph data:", error);
            setDialogText(`Error fetching graph data: ${(error as any).message}`);
            setDialogVisible(true);
        }
    };

    const getMessageById = async (id: string) => {
        try {
            const provider = microsoftGlobalProvider;

            if (!provider || provider.state !== ProviderState.SignedIn) {
                if (provider?.login) {
                    await provider.login();
                }
            }

            if (provider && provider.state === ProviderState.SignedIn) {
                await provider.getAccessToken({ scopes: ["User.Read", "Mail.Read", "Calendars.Read"] });

                const graphClient = provider.graph.client;
                const cleanId = id.replaceAll("/", "-");
                const message = await graphClient.api(`/me/messages/${cleanId}`)
                    .select('subject,bodyPreview,receivedDateTime,hasAttachments,webLink')
                    .get();

                const newNode = {
                    id: `message-${id}`,
                    type: 'customNode',
                    data: {
                        label: `${message.subject}`,
                        body: `${message.bodyPreview}`,
                        receivedDateTime: `${message.receivedDateTime}`,
                        hasAttachments: `${message.hasAttachments ? 'Has Attachments' : 'No Attachments'}`,
                        webLink: `${message.webLink}`,
                        bookmarked: false
                    },
                    position: { x: Math.random() * 400, y: Math.random() * 400 },
                };

                setNodes((nds) => [...nds, newNode]);
            }
        } catch (error) {
            console.error("Error fetching message by ID:", error);
            setDialogText(`Error fetching message by ID: ${(error as any).message}`);
            setDialogVisible(true);
        }
    };

    const handleNodeClick = (event: React.MouseEvent, node: Node) => {
        setSelectedNode(node);
    };

    // const handleAddNode = () => {
    //     const newNode = {
    //         id: `node-${nodes.length + 1}`,
    //         type: 'customNode',
    //         data: { label: `Node ${nodes.length + 1}`, body: "" },
    //         position: { x: Math.random() * 400, y: Math.random() * 400 },
    //     };

    //     setNodes((nds) => [...nds, newNode]);

    //     if (selectedNode) {
    //         const newEdge = { id: `e${selectedNode.id}-${newNode.id}`, source: selectedNode.id, target: newNode.id, type: "default" };
    //         setEdges((eds) => [...eds, newEdge]);
    //     }
    // };

    const handleNodesChange = (changes: NodeChange[]) => {
        setNodes((nds) => applyNodeChanges(changes, nds));
    };

    const handleEdgesChange = (changes: EdgeChange[]) => {
        setEdges((eds) => applyEdgeChanges(changes, eds));
    };

    const handleHomepageClick = () => {
        navigate("/");
    };

    const handleQuestionSubmit = async (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            const question = (event.target as HTMLInputElement).value;
            if (question.trim() === "") return;

            try {
                if (question.startsWith("message:")) {
                    const messageId = question.split(":")[1].trim();
                    await getMessageById(messageId);
                } else {
                    setMyQuery(question);
                }
            } catch (error) {
                console.error("Error fetching CoPilot response:", error);
                const errorMessage = (error as any).message;
                setDialogText(JSON.stringify(("Error fetching CoPilot response: " + errorMessage))); setDialogVisible(true)
            }
        }
    };

    const handleDrop = async (event: React.DragEvent) => {
        event.preventDefault();
        const items = event.dataTransfer.items;
        for (let i = 0; i < items.length; i++) {
            if (items[i].kind === 'file') {
                const file = items[i].getAsFile();
                if (file) {
                    setDialogText(`File name: ${file.name}`);
                    setDialogVisible(true);
                }
            } else if (items[i].kind === 'string') {
                items[i].getAsString((data) => {

                    const parsedData = JSON.parse(data);
                    const emailIds = parsedData.latestItemIds || []; // Ensure it's always an array
                    if (emailIds.length > 0) {
                        const messageId = emailIds[0];  // Get the first email ID
                        // console.log("First Outlook Email ID:", messageId);
                        getMessageById(messageId);

                    } else {
                        console.log("No email ID found.");
                    }


                    // setDialogText(`Link info: ${data}`);
                    // setDialogVisible(true);
                });
            }
        }
    };

    const handleDragOver = (event: React.DragEvent) => {
        event.preventDefault();
    };

    return (
        <>
            <div style={{ height: "100%", width: "100%" }} onDrop={handleDrop} onDragOver={handleDragOver}>
                <ReactFlow
                    className="canvas"
                    nodes={nodes}
                    edges={edges}
                    onNodesChange={handleNodesChange}
                    onEdgesChange={handleEdgesChange}
                    onNodeClick={handleNodeClick}
                    onNodeDoubleClick={(event, node) => {
                        if (node.data.webLink) {
                            window.open(`${node.data.webLink}`);
                        }
                    }}
                    nodeTypes={nodeTypes}
                    proOptions={proOptions}
                />
            </div>
            <h1 className="focus365-homepage-title" onClick={handleHomepageClick}>Playground</h1>
            <h2 className="focus365-homepage-subtitle" onClick={handleHomepageClick}>...back to Home Page</h2>
            <div className="focus365-input-area">
                <IconField iconPosition="right">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText id="question" className="focus365-input-field" placeholder="What do you want to focus on?" onKeyDown={handleQuestionSubmit} />
                </IconField>
            </div>
            {/* <img src={copilot} className="focus365-copilot" alt="copilot" onClick={() => { setDialogText("FocusMap 365 is CoPilot driven."); setDialogVisible(true) }} /> */}
            {/* <button onClick={handleAddNode}>Add Node</button> */}

            <div className="card flex justify-content-center">

                <Dialog header="CoPilot" visible={dialogVisible} style={{ width: '50vw' }} onHide={() => { if (!dialogVisible) return; setDialogVisible(false); }}>
                    <p className="m-0">
                        {dialogText}
                    </p>
                </Dialog>
            </div>
        </>
    );
};

export default Focus365;
